import { Suspense, lazy } from 'react'
import type { PanelProps } from '@/workspace/types'

/**
 * Dashboard panel entry for the EdgeScript editor (Task 2.10). Same gate shape as
 * `lazy-script-panel.tsx`: the flag expression is repeated inline so the bundler drops
 * the dynamic import (and the language chunk behind it) from user builds. Keep it
 * identical to `EDGESCRIPT_ENABLED` in `flags.ts` (the unit test pins them).
 */
const ScriptEditorPanelImpl =
  import.meta.env.DEV ||
  ((import.meta.env.MODE === 'staging' || import.meta.env.MODE === 'prod') &&
    import.meta.env.VITE_EDGESCRIPT === 'true')
    ? lazy(() => import('./script-editor-panel').then((m) => ({ default: m.ScriptEditorPanel })))
    : null

export function LazyScriptEditorPanel(props: PanelProps) {
  if (!ScriptEditorPanelImpl) return null
  return (
    <Suspense fallback={null}>
      <ScriptEditorPanelImpl {...props} />
    </Suspense>
  )
}
